__turbopack_context__.v({
  "form": "CheckoutForm-module__DP_ajG__form",
  "formCard": "CheckoutForm-module__DP_ajG__formCard",
  "input": "CheckoutForm-module__DP_ajG__input",
  "row": "CheckoutForm-module__DP_ajG__row",
  "title": "CheckoutForm-module__DP_ajG__title",
});
